export default __webpack_public_path__ + "static/backgroundHeader-0f3cf6c46e3737a290a8d626f73cbe7f.jpeg";